import { combineReducers } from "redux-starter-kit";
import newdisposalSlice from "../wizard/state/disposalSlice";
import contactSlice from "../wizard/state/contactSlice";
import navigationSlice from "../wizard/state/navigationSlice";

const rootReducer = combineReducers({
    disposal: newdisposalSlice,
    contact: contactSlice,
    navigation: navigationSlice
});


export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
